import dexie from 'dexie'

const db = new dexie('brames')

db.version(1).stores({
	posts: '++id, userId',
	subjects: '++id, name',
})

export default db